import { EventEmitter } from "pixi.js";


export enum EnumEventBus {
    moveCircumPoint = "MOVE_CIRCUMFERENCE_POINT",
    moveChord = "MOVE_CHORD"
}


export const eventBus = new EventEmitter();